import { render } from "./StatusCard.vue?vue&type=template&id=524e64f5&ts=true"
import script from "./StatusCard.vue?vue&type=script&lang=ts"
export * from "./StatusCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__